import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-hal.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-sc-reverse-scan/icon-sti-sc.svg'


const _hoisted_1 = {
  class: "flex flex-col gap-2 justify-center",
  style: {"width":"fit-content"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "hal-icon"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col gap-4 justify-center items-center",
  style: {"width":"fit-content"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "icon-sti",
    width: "376.88",
    height: "130"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isHal)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _hoisted_4
  ]))
}